import { createReducer } from '@src/redux/helpers/createReducer';

import { VALIDATE_TIN, SET_TIN, RESET_TIN_INFO } from './constants';

const initialState = {
  TINNumber: '',
  TINInfo: { paaInfo: null },
  TINInfoSaga: { isLoading: false, isError: false, isSuccess: false },
};

export const TINReducer = createReducer(initialState, {
  [SET_TIN]: (state, action) => {
    return {
      ...state,
      TINNumber: action.payload,
    };
  },
  [RESET_TIN_INFO]: (state, action) => {
    return { TINInfo: null };
  },
  [`${VALIDATE_TIN}_SUCCESS`]: (state, action) => {
    return {
      ...state,
      TINInfo: { ...action.payload },
      TINInfoSaga: {
        isLoading: false,
        isError: false,
        isSuccess: true,
      },
    };
  },
  [`${VALIDATE_TIN}_ERROR`]: (state, action) => {
    return {
      TINInfoSaga: {
        isLoading: false,
        isError: true,
        isSuccess: false,
      },
    };
  },
  [`${VALIDATE_TIN}_STARTED`]: (state, action) => {
    return {
      TINInfoSaga: {
        isLoading: true,
        isError: false,
        isSuccess: false,
      },
    };
  },
});
